import { VenueOperatorContactPersonType } from '@api';
import {
  ContactDetails,
  PersonAnchor,
  TouringCardTableRow,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';

type ContactPersonsTableRowPropsType = {
  contactPerson: VenueOperatorContactPersonType;
};

export const ContactPersonsTableRow: React.FC<
  ContactPersonsTableRowPropsType
> = ({ contactPerson }) => {
  const { t } = useTranslation();

  const noDataPlaceholder = t('NO_DATA_PLACEHOLDER');

  return (
    <TouringCardTableRow>
      <TouringCardTableRowValue>
        <PersonAnchor person={contactPerson.person} />
      </TouringCardTableRowValue>
      <TouringCardTableRowValue>
        {contactPerson.jobTitle || noDataPlaceholder}
      </TouringCardTableRowValue>
      <TouringCardTableRowValue>
        <ContactDetails contact={contactPerson.contact} />
      </TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
